module.exports = __webpack_public_path__ + "static/media/Mastercard.4bcb6880.svg";